/*!
 * Positrex 3
 * Copyright 2023 Level s.r.o.
 */

import Cookies from "node_modules/js-cookie";

import {
	handlePanels,
	initMobileMenu,
	initShowModal,
	isDesktop,
	isMobile,
	move,
	openPtx
} from "./main_ptx";
import {hideCurrent, show} from "./main_modal";

if (typeof String.prototype.endsWith !== 'function') {
	String.prototype.endsWith = function(suffix) {
		return this.indexOf(suffix, this.length - suffix.length) !== -1;
	};
}
if (typeof String.prototype.startsWith !== 'function') {
	String.prototype.startsWith = function(needle) {
	    return(this.indexOf(needle) == 0);
	};
}
if (typeof String.prototype.contains !== 'function') {
	String.prototype.contains = function(it) { return this.indexOf(it) != -1; };
}

if (typeof String.prototype.replaceAll !== 'function') {
	String.prototype.replaceAll = function(search, replacement) {
	  var target = this;
	  return target.replace(new RegExp(search, 'g'), replacement);
	};
}

if (typeof String.prototype.escapeSelector !== 'function') {
	/**
	 * Escape special characters in string used typically as id selector. Usage with JQuery e.g. $("#data['${thresholdUnit}']".escapeSelector())
	 * @returns String with special characters escaped by '\\'
	 */
	String.prototype.escapeSelector = function () {
		return this.replace(/([$()\[\]{}'"])/g, '\\$1');
	};
}

if (typeof String.prototype.stripHTMLTags !== 'function') {
	String.prototype.stripHTMLTags = function () {
		return this.replace(/(<([^>]+)>)/ig, "");
	}
}


/**
 * @alias Ptx.fullScreen
 * @param obj
 */
export function fullScreen(obj) {
	var elementId = $(obj).data("target");
	var element = $('#' + elementId);

	if (element.hasClass('fullscreen')) {
		element.removeClass('fullscreen');
		$('.fullscreen-btn').css('display', 'none');
	} else {
		element.addClass('fullscreen');
		$('.fullscreen-btn').css('display', 'block');
	}
}

/**
 * @alias Ptx.captionSlide
 * @param obj
 */
export function captionSlide(obj) {
	var parent = $(obj).parent().parent();
	var hiddenElement = parent.find('thead, tbody, tfoot');
	var isHidden = hiddenElement.is(':hidden');

	if (isHidden == false) {
		hiddenElement.toggle("slide");
	} else {
		hiddenElement.show(1000);
	}
}

/**
 * @alias Ptx.leftSlider
 * @param obj
 */
export function leftSlider(obj) {
	var isOff = $(obj).hasClass('slide-off');
	var target = $(obj).data('target');

	if (isOff == true) {
		$(obj).removeClass('slide-off');
		$(obj).find('.fa-solid fa-chevron-right')
			  .removeClass('fa-solid fa-chevron-right')
			  .addClass('fa-solid fa-chevron-left');
		$(obj).animate({
			left : "90%"
		});
		$(target).animate({
			left : "0%"
		});
	} else {
		$(obj).addClass('slide-off');
		$(obj).find('.fa-solid fa-chevron-left')
			  .removeClass('fa-solid fa-chevron-left')
			  .addClass('fa-solid fa-chevron-right');
		$(obj).animate({
			left : "0%"
		});
		$(target).animate({
			left : "-100%"
		});
	}
}


/**
 * @alias Ptx.initTaxRecalc
 * @param
 */
export function initTaxRecalc(triggerBtn, priceField, taxField, priceWithoutTaxField) {
	triggerBtn.on('click', function(e) {
		e.preventDefault();
		let noTax = parseFloatLocalized(priceWithoutTaxField.val());
		let withTax = parseFloatLocalized(priceField.val());
		let tax = parseFloatLocalized(taxField.val());
		let finalPrice = "";

		if (!noTax || noTax <= 0) {
			finalPrice = Number(withTax / (1 + (tax / 100))).toFixed(2).toString();
			priceWithoutTaxField.val(Number(finalPrice).toLocaleString(Ptx.lang));
		} else {
			finalPrice = Number(noTax * (1 + (tax / 100))).toFixed(2).toString();
			priceField.val(Number(finalPrice).toLocaleString(Ptx.lang));
		}
	});
}

/**
 * Parse a localized number to a float.
 * @alias Ptx.parseFloatLocalized
 * @param {string} stringNumber - the localized number
 */
export function parseFloatLocalized(val){
	/*
		These 4 lines find and replace the numbers based on browser locale that was received from the locale variable.
		First line separates thousands, second line replaces the decimal point.
		The "g" parameter in the replace functions means that it searches for this number globally - it doesn't stop after the first occurrence.
		Last return function checks if the result is a number - if not, it inputs a 0 instead.
	*/
	var group = new Intl.NumberFormat(Ptx.lang).format(1111).replace(/1/g, ''); // thousands
	var decimal = new Intl.NumberFormat(Ptx.lang).format(1.1).replace(/1/g, ''); // decimal point

	var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
	reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
	return reversedVal;
}

/**
 * @alias Ptx.resizeToBottomCorner
 * @param objClass
 * @param h
 * @param mobileToo
 */
export function resizeToBottomCorner(objClass, h, mobileToo) {
	if (isMobile() && (mobileToo != true)) {
		$(objClass).each(function() {
			$(this).removeClass(objClass);
		});
	} else {
		var heightWindow = $(window).height();
		$(objClass).each(function() {
			var offsetTop = $(this).offset().top;
			var height = heightWindow - offsetTop;
			$(this).css(h, height);
		});
	}
}

/**
 * Set visibility for element with loading indicator during ajax request
 * @alias Ptx.showLoading
 * @param {Boolean} visible Loading visibility
 * @param {String} flag Type of loading
 * @param {String} element selector of loader element
 */
export function showLoading(visible, flag, element) {
    if (!element) {
        element = '#loader';
    }
	var $loader = $(element);
	if ($loader.length === 0) {
        console.error(`${element} not found!`);
		return;
	}
	var	$elem = $loader[0].dataset;
	var	location = [];

	$loader.attr('data-load-' + flag, visible);

	for (var value in $elem) {
		location.push($elem[value]);
	}

	if ($.inArray('true', location) > -1) {
		$loader.removeClass('hidden');
	} else {
		$loader.addClass('hidden');
	}
}

/**
 * @alias Ptx.showAllChild
 * @param obj
 */
export function showAllChild(obj) {
	var iChild = $(obj).children('i');
	if (iChild.hasClass('fa-plus')) {
		iChild.removeClass('fa-plus').removeClass('text-private');
		iChild.addClass('fa-minus').addClass('text-alarm');

		$('.ptx-table').find('.btn-more').has('i.fa-plus').each(function() {
			showChild(this);
		});
	} else {
		iChild.removeClass('fa-minus').removeClass('text-alarm');
		iChild.addClass('fa-plus').addClass('text-private');

		$('.ptx-table').find('.btn-more').has('i.fa-minus').each(function() {
			showChild(this);
		});
	}
}

/**
 * @alias Ptx.showChild
 * @param obj
 * @param all
 */
export function showChild(obj, all) {
	var rowId = $(obj).parent().closest('tr').attr('id');
	var iChild = $(obj).children('i');
	if (iChild.hasClass('fa-plus')) {
		iChild.removeClass('fa-plus').removeClass('text-private');
		iChild.addClass('fa-minus').addClass('text-alarm');
		$("tr[data-child-of='" + rowId + "']").removeClass('hidden');
	} else {
		iChild.removeClass('fa-minus').removeClass('text-alarm');
		iChild.addClass('fa-plus').addClass('text-private');
		$("tr[data-child-of='" + rowId + "']").addClass('hidden');
	}
}

/**
 * Display a Bootstrap alert with a warning style.
 * @param {string} title - The title of the alert.
 * @param {string} text - The text content of the alert.
 * @param {boolean} sticky - Whether the alert should be sticky or disappear after a certain time.
 */
export function _warning(title, text = "",  sticky = false) {
	showToast(title, text, 'warning', sticky);
}

/**
 * Display a Bootstrap alert with an error style.
 * @param {string} title - The title of the alert.
 * @param {string} text - The text content of the alert.
 * @param {boolean} sticky - Whether the alert should be sticky or disappear after a certain time.
 */
export function _error(title, text = "", sticky = false) {
	showToast(title, text, 'error', sticky);
}

/**
 * Display a Bootstrap alert with specified type (success, info, warning, error).
 * @param {string} title - The title of the alert.
 * @param {string} text - The text content of the alert.
 * @param {string} noteType - Available options (success, info, warning, error).
 * @param {boolean} sticky - Whether the alert should be sticky or disappear after a certain time.
 * @param {number} time - Time in milliseconds before the alert disappears (if not sticky).
 */
export function message(title, text = "", noteType = "success", sticky = false, time = 5000) {
	showToast(title, text, noteType, sticky, time);
}

function showToast(title, text = "", alertType = "success", sticky = false, time = 5000) {
	const containerId = 'toast-container';
	let container = $('#' + containerId);

	if (!container.length) {
		container = $('<div></div>').attr('id', containerId).addClass('position-fixed');
		$('body').append(container);
	}

	const alertTypes = {
		'success': 'alert-success',
		'info': 'alert-info',
		'warning': 'alert-warning',
		'error': 'alert-danger'
	};

	const iconTypes = {
		'success': 'check',
		'info': 'circle-info',
		'warning': 'triangle-exclamation',
		'error': 'xmark'
	};

	const alertClass = alertTypes[alertType] || 'alert-success';
	const iconClass = iconTypes[alertType] || 'check';

	const alertDiv = $('<div></div>').addClass('alert ' + alertClass + ' fade show alert ptx-toast').attr('role', 'alert').html(`
	<i class="fa fa-fw fa-${iconClass}"></i>
    <strong>${title}</strong><br> ${text}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  `);

	container.append(alertDiv);

	if (!sticky) {
		setTimeout(() => {
			alertDiv.removeClass('show');
			setTimeout(() => {
				alertDiv.remove();
				if (!container.children().length) {
					container.remove();
				}
			}, 500);
		}, time);
	}
}

/**
 * @alias Ptx.alert
 * @param msg
 */
export function _alert(msg){
	bootbox.alert({
		message: msg,
		onHide: bootboxHandleHide
	});
}

/**
 * @alias Ptx.confirm
 * @param msg
 * @param confirmationCallback
 * @param size can be 'sm', 'lg' or 'xl'
 */
export function _confirm(msg, confirmationCallback, size){
	bootbox.confirm({
		message: msg,
		callback: function(result) {
			confirmationCallback(result);
			Ptx.fn.reloadContentAll();
		},
		size: size,
		onHide: bootboxHandleHide,
	});
}

/**
 * @alias Ptx.prompt
 * @param msg
 * @param callback
 */
export function _prompt(msg, callback){
	bootbox.prompt({
		message: msg,
		callback: callback,
		onHide: bootboxHandleHide
	});
}

/**
 * Callback that handle modal state (open/close) + modal scrolling
 * @param {object} e Bootbox event
 */
function bootboxHandleHide(e) {
	// Check if there's a Bootbox modal open
	if (!Ptx.modal.ctx) {
		$('.modal-backdrop').remove();
	} else {
		var $body = $('body');

		// Create a promise to wait for the observer to finish its work
		var addModalOpenClass = new Promise(function (resolve) {
			var observer = new MutationObserver(function () {
				if (!$body.hasClass('modal-open')) {
					$body.addClass('modal-open');
					// Disconnect the observer after the class is added and resolve the promise, so we can continue with other code
					observer.disconnect();
					resolve();
				}
			});
			observer.observe($body[0], { attributes: true, attributeFilter: ['class'] });
		});

		// Wait for the promise to resolve, then check Ptx.modal.ctx, if there's no modal left, remove modal-open.
		addModalOpenClass.then(function () {
			if (!Ptx.modal.ctx) {
				$body.removeClass('modal-open');
			}
		});
	}
	$('.bootbox.modal').remove();
}



/**
 * @alias Ptx.isMenuTooBig
 * @param find
 * @return {boolean|number}
 */
export function isMenuTooBig(find){
	Ptx.tooBigCount++;
	if (Ptx.tooBigCount < 20) {return -1}
	var $menu = $('#ptx-menu .ptx-menu');
	var $logo = $('#ptx-menu .navbar-brand')
	var ulWidth = $menu.width()+33-$logo.width();
	var liWidth = 0;
	$menu.find(find).each(function() {
		var $a = $(this).find(">a");
		var aWidth = $a.width();
		if (typeof aWidth !== "undefined") {
			liWidth += (aWidth + 30);
		}
	});
	return ulWidth < liWidth;
}

/**
 * @alias Ptx.rebaseMenu
 */
export function rebaseMenu() {
	var $menu = $('#ptx-menu .ptx-menu');

	if ($menu.length && $("#ptx-menu").is(":visible")) {
		if (isMenuTooBig('>li:not(.hidden):not(#more)') === true) {
	
			$('#more').css('display','block');
			$($menu.find('>li:not(.pull-right):not(.hidden):not(#more)').get().reverse()).each(function(){
				$(this).addClass('hidden');
				var id = $(this).attr('id');
				$('#more-'+id).removeClass('hidden');
				return false;
			});
			
			if (isMenuTooBig('>li:not(.hidden):not(#more)')) {
				rebaseMenu();
			}
		} else {
			$('#more').css('display','none');
			$menu.find('>li.hidden:not(#more)').each(function(){
				$(this).removeClass('hidden');
				var id = $(this).attr('id');
				$('#more-'+id).addClass('hidden');
				rebaseMenu();
				return false;
			});
		}
	}
}

/*
 * height element to for class .absHeight
 */
$(window).resize(function() {
	if (isDesktop()) {
		rebaseMenu();
	}

	resizeToBottomCorner('.abs-height', 'height');
	resizeToBottomCorner('.abs-max-height', 'max-height');

	if (!Ptx.modal.ctx) {
		if ((Ptx.windowWidth < 1260 && isDesktop()) || (Ptx.windowWidth > 1260 && isMobile())) {
			location.reload();
		}
	}
});


$(document).ready(function() {
	Ptx.windowWidth = $(window).width();
	const ptxMenu = $('#ptx-menu');

	$('.dropdown-toggle', ptxMenu).on('click', function (e) {
		e.stopPropagation(); // Prevent the click event from propagating to the document body

		var menu = $(this);
		var href = menu.attr('href');
		var clickedUl = menu.next('ul.dropdown-menu');

		// Hide all other visible dropdown-menus except the clicked one
		ptxMenu.find($('.dropdown-toggle + ul.dropdown-menu.show')).not(clickedUl).removeClass('show');

		if (href == '#\/_') {
			e.preventDefault();
			var link = $('a', $('ul.dropdown-menu', menu.parent()).first('li')).attr('href');
			location.hash = link;
		}
	});

	window.onhashchange = function() {
		// Abort all ajax requests
		//if (Ptx.ajax){Ptx.ajax.abort();}
		//if (Ptx.modal.ajax){Ptx.modal.ajax.abort();} // CANNOT KILL!
		//if (Ptx.form.ajax){Ptx.form.ajax.abort();}  // CANNOT KILL!
		
		// need when changing page
		$("body").css('min-height', "");
		
		if (location.hash.startsWith('#error')) {
			_error("Error", location.hash.replace('#error=',''));
		}
	};
	
	if(isDesktop()){
		rebaseMenu();
	}
	
	if (isMobile()){
		move('#ptx-filter', '#page-filter');
	}
	
	$('#filter').removeClass('hidden');

	$('.do-fullScreen').click(function() {
		fullScreen(this);
	})

	$('.do-captionSlide').click(function() {
		captionSlide(this);
	})

	$('.do-leftSlider').click(function() {
		leftSlider(this);
	})

	handlePanels();
	initMobileMenu();
	initShowModal($('#ptx-menu,#panel-menu'));
	
	/* precise location indicators */
	var parent = $('.ptx-handle').parent();
	var pLeft = parent.css('padding-left');
	// var pTop = parent.css('padding-top');
	var height = parent.height();
	var pTop = (height - 16) / 2;

    /*
     * For handle using color in Grid
     */
    $('.ptx-handle').css({marginLeft: '-' + pLeft, marginTop: pTop + 'px'});

	resizeToBottomCorner('.abs-height', 'height');
	resizeToBottomCorner('.abs-max-height', 'max-height');

	// Function to initialize tooltips

	initTooltips();

	if (typeof Ptx.module.init == 'function') {
		Ptx.module.initModules();
	}

	function applyDesktopStyles() {
		var stylesheets = document.styleSheets;
		$("#ptx-menu, .nav > li").css("display", "inline-block");
		for (var i = 0; i < stylesheets.length; i++) {
			var stylesheet = stylesheets[i];
			var rules = stylesheet.rules || stylesheet.cssRules;
			for (var j = 0; j < rules.length; j++) {
				var rule = rules[j];
				if (rule.media && rule.media.mediaText.includes("max-width: 1259px") && !(rule.media.mediaText.match(/menu|ptx-menu|nav/g))) {
					stylesheet.deleteRule(j);
				}
			}
		}
	}

	var queryString = window.location.search;

	if(queryString.indexOf("md_switch=mobile") != -1){
		sessionStorage.setItem("md_switch", "mobile");
	}

	if (queryString.indexOf("md_switch=desktop") != -1) {
		applyDesktopStyles();
		sessionStorage.setItem("md_switch", "desktop");
	} else if (sessionStorage.getItem("md_switch") === "desktop") {
		applyDesktopStyles();
	}

});

/**
 * Tooltip & Popover Initialization
 * @alias Ptx.initializeTooltips
 * @param ctx context
 */
export function initTooltips(ctx) {
	ctx = ctx || document;

	$('[data-bs-toggle="popover"]', ctx).each(function () {
		var $this = $(this);
		var content = $this.data('content');
		
		if (!content) {
			var webuiContent = $this.find('.webui-popover-content').html();
			if (!webuiContent) {
				webuiContent = $this.next('.webui-popover-content').html();
			}
			content = webuiContent;
		}
		content = content || '';

		$this.attr('data-bs-custom-class', 'ptx-popover');
		$this.popover({
			trigger: $this.hasClass('click-popover') ? 'click' : 'hover',
			html: true,
			content: content
		});
		
		// Hide popover when clicking outside
		$(document).on('click', function (e) {
			var popoverId = $this.attr('aria-describedby');
			var $popoverEl = popoverId ? $('#' + popoverId) : $();
			
			if (
				!$this.is(e.target) &&
				$this.has(e.target).length === 0 &&
				$popoverEl.has(e.target).length === 0 &&
				!$popoverEl.is(e.target)
			) {
				$this.popover('hide');
			}
		});
		
		// We need to make sure that titles won't show up when a popover element is visible.
		$this.on('mouseenter', function() {
			$this.attr('data-original-title', $this.attr('title')).removeAttr('title');
		}).on('mouseleave', function() {
			if ($this.attr('data-original-title')) {
				$this.attr('title', $this.attr('data-original-title')).removeAttr('data-original-title');
			}
		});
	});


	$('[data-bs-toggle="tooltip"]', ctx).each(function () {
		$(this).attr('data-bs-custom-class', 'ptx-tooltip');
		$(this).tooltip({
			trigger: 'hover',
			container: 'body'
		}).on('click', function () {
			$(this).tooltip('hide');
		})
	});
}

// OLD MAIN.JS functions
/**
 * @alias Ptx.getBorderColor
 * @param color
 * @return {string|string}
 */
export function getBorderColor(color) {
	if (color) {
		var red = parseInt(color.substr(0, 2), 16);
		var green = parseInt(color.substr(2, 2), 16);
		var blue = parseInt(color.substr(4, 2), 16);

		return (((red * 299) + (green * 587) + (blue * 144)) / 1000) >= 131.5 ? "black" : "white";
	} else {
		return "white";
	}
}

/**
 * @alias Ptx.toggleAllCheckbox
 * @param selector
 * @param value
 */
export function toggleAllCheckbox(selector, value) {
	if (value) {
		$(selector).prop('checked', true);
	} else {
		$(selector).prop('checked', false);
	}
}

/**
 * Handle cookies bar
 * @alias Ptx.handleCookies
 */
export function handleCookies() {
    const cookieName = "COOKIE-USER-CONSENT";

    function cookiesHandling(consentValue) {
        Cookies.set(cookieName, consentValue, {expires: 365, path: '/'});
        $('.cookies').remove();
        $(this).off('click');
    }

    if (!Cookies.get(cookieName)) {
        $('.cookies').removeClass('hidden');
        // Acceptance of all cookies.
        $('.cookies-all-btn').on('click', function () {
            cookiesHandling.call(this, 'functional,all');
        });
        // Acceptance of only the necessary cookies. You can still see cookie 'NID' from domain '.google.com' even if user chooses this setting,
        // because we're also using 'reCAPTCHA' and 'Maps' from Google, so this cookie comes from these services.
        $('.cookies-functional-btn').on('click', function () {
            cookiesHandling.call(this, 'functional');
        });
    }
}

/**
 * Handle search box highlight
 * @alias Ptx.handleSearchBox
 */
export function handleSearchBox() {
	var search = document.getElementById('searched');
	if (!search) return; // prevent missing element

	search.addEventListener('input', handleInputValue);
	handleInputValue();

	function handleInputValue() {
		if (search.value.length > 0) {
			handleClass(false);
		} else {
			handleClass(true);
		}
	}

	/**
	 * Toggle element class by condition
	 * @param {Boolean} isEmpty If search field is empty
	 */
	function handleClass(isEmpty) {
		var className = "highlight-input";
		var containsClass = search.classList.contains(className);

		if (!isEmpty && !containsClass) {
			search.classList.add(className);
		} else if (isEmpty && containsClass) {
			search.classList.remove(className);
		}
	}
}

/**
 * Performs POST request to URL given by href attribute of target element of given event.
 * @alias Ptx.post
 * @param e event from element ('a' element with href attribute is expected)
 */
export function post(e) {
	e.preventDefault();
	const tgt = e.target.getAttribute('href');
	const curr = window.location.pathname;
	openPtx(tgt+"#"+curr, "POST", null, null, {forceReload:true});
}

/**
 * Performs logout via ptx3:logout tag defined in logout.tag file. Placed here for reason to not have this JS fragment
 * in page repeatedly according to usage of tag in different places (menu, mobile menu, modal dialog,...)
 * @alias Ptx.logout
 */
export function logout() {
	// Treatment of logout from modal dialog. There is possibility that some modal dialog uses interval to refresh it's content.
	// This refresh can break redirect to login page after logout! It's supposed, that dialogs listen to Ptx.modal.ctx.onunload
	// event where this interval will be cleared and also all other 'onunload' operations will be make in function that reacts on this event.
	// So closing of this dialog should enough to end all this periodical functionalities that may leads to logout malfunction.
	if (Ptx.modal !== undefined && Ptx.modal.ctx !== undefined) {
		hideCurrent();
	}
	// logoutForm is placed in _decorator/page.jsp to not be repeated on page more than once.
	$('#logoutForm').submit();
}

/**
 * @alias Ptx.now
 * @return {number}
 */
export function now() {
	return new Date().getTime();
}